import React, { forwardRef } from "react";
import ReactSelect from "react-select";
import { useTheme } from "@material-ui/core";
import colors from "Styles/colors";

// TODO: props type needs to be the one for ReactSelect props, but typings are messed up atm
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DPReactSelect = forwardRef((props: any, ref: any) => {
  const theme = useTheme();
  return (
    <ReactSelect
      {...props}
      ref={ref}
      // TODO: props type needs to be Theme from react-select, but typings are messed up atm
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      theme={(reactSelectTheme: any) => ({
        ...reactSelectTheme,
        colors: {
          ...reactSelectTheme.colors,
          primary: colors.grayMedLight,
          primary75: colors.grayMedLight,
          primary50: theme.palette.grey[200],
          primary25: theme.palette.grey[100],
        },
      })}
      styles={{
        ...props.styles,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        option: (provided: any, state: any) => ({
          ...provided,
          color: colors.black,
          backgroundColor: (state.isFocused || state.isSelected) ? colors.grayMedLight : "inherit",
        }),
      }}
    />
  );
});
